export type PaymentMethods = (typeof PaymentMethod)[keyof typeof PaymentMethod]
export const PaymentMethod = {
  CreditCard: 'PAYMENT_CREDITCARD',
  Cash: 'PAYMENT_CASH',
  Invoice: 'PAYMENT_INVOICE',
  Mobile: 'PAYMENT_MOBILE',
  Rounding: 'PAYMENT_ROUNDING',
  Cheque: 'PAYMENT_CHEQUE',
  Voucher: 'PAYMENT_VOUCHER',
  ConsolidatedInvoice: 'PAYMENT_CONSOLIDATED_INVOICE',
  Prepayment: 'PAYMENT_PREPAYMENT',
  PresentCard: 'PAYMENT_PRESENT_CARD',
  FinancingCompany: 'PAYMENT_FINANCING_COMPANY',
  Other: 'PAYMENT_OTHER',
  CreditInvoice: 'PAYMENT_CREDIT_INVOICE',
  InsuranceClaim: 'PAYMENT_INSURANCE_CLAIM',
  KlarnaInstore: 'PAYMENT_KLARNA_INSTORE',
  LindorffInvoicing: 'PAYMENT_LINDORFF_INVOICING',
  SavFinancing: 'PAYMENT_SAV_FINANCING',
  NordhealthPayments: 'PAYMENT_NORDHEALTH_PAYMENTS',
  InternalTransfer: 'PAYMENT_INTERNAL_TRANSFER',
  SveaFinancing: 'PAYMENT_SVEA_FINANCING',
  Frakmenta: 'PAYMENT_FRAKMENTA',
  CustomPayment: 'PAYMENT_CUSTOM',
} as const

export const PaymentMethodCode = {
  [PaymentMethod.CreditCard]: '0',
  [PaymentMethod.Cash]: '1',
  [PaymentMethod.Invoice]: '2',
  [PaymentMethod.Rounding]: '3',
  [PaymentMethod.Cheque]: '4',
  [PaymentMethod.Voucher]: '5',
  [PaymentMethod.ConsolidatedInvoice]: '6',
  [PaymentMethod.Mobile]: '7',
  [PaymentMethod.Prepayment]: '8',
  [PaymentMethod.PresentCard]: '9',
  [PaymentMethod.FinancingCompany]: '10',
  [PaymentMethod.Other]: '11',
  [PaymentMethod.CreditInvoice]: '12',
  [PaymentMethod.InsuranceClaim]: '15',
  [PaymentMethod.KlarnaInstore]: '5000',
  [PaymentMethod.LindorffInvoicing]: '5001',
  [PaymentMethod.SavFinancing]: '5002',
  [PaymentMethod.NordhealthPayments]: '5003',
  [PaymentMethod.InternalTransfer]: '5004',
  [PaymentMethod.SveaFinancing]: '5005',
  [PaymentMethod.Frakmenta]: '5006',
  [PaymentMethod.CustomPayment]: '5007',
} as const
